import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { CarrierFeedback, ContactsTable, RestService, TruckSearchTable } from 'cargo-chief-commons';
import { UrlService } from '@service/url/url.service';
import { SegmentEventsConstants } from '@domain/constants/segment-events-constants';
import { SegmentWrapperService } from '@service/segmentWrapper/segment-wrapper.service';
import { UtilService } from '@service/util/util.service';
import { SNACKBAR } from '@domain/constants/snackbar-setting';
import { Cargochief } from '@service/cargochief/cargochief.service';
import { ACCOUNT_TYPE } from '@domain/constants/app-variables';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { AccountSettingsService } from '@service/accountSettings/account-settings.service';
import { CarrierFeedbackService } from '@service/carrierFeedback/carrier-feedback.service';
import { ProductsService } from '@service/products/products.service';

@Component({
	selector: 'app-pannel-body',
	templateUrl: './pannel-body.component.html',
	styleUrls: ['./pannel-body.component.scss'],
})
export class PannelBodyComponent implements OnInit {
	@Input() editPrimaryContact: boolean = false;
	@Input() capacitySearch: TruckSearchTable = null;
	@Input() searchTruckForm = null;
	@Output() customerCarrierUpdated: EventEmitter<any> = new EventEmitter();
	@Output() emitUserResponse: EventEmitter<CarrierFeedback> = new EventEmitter();
	@Output() openLaneDetails = new EventEmitter<any>();
	@Output() recentFeedbackList: EventEmitter<Array<CarrierFeedback>> = new EventEmitter();
	@Output() feedbackClicked: EventEmitter<any> = new EventEmitter();

	contactList: ContactsTable[] = null;
	accountId: number;
	ACCOUNT_TYPE = ACCOUNT_TYPE;
	USER_ACCOUNT_TYPE: string = null;
	userResponseSegmentPayload: CarrierFeedback = null;
	feedbackExists = false;
	SegmentEventsConstants = SegmentEventsConstants;
	isContactsListInProgress: boolean = false;

	constructor(
		private urlService: UrlService,
		private restService: RestService,
		private segmentWrapper: SegmentWrapperService,
		private cargochief: Cargochief,
		public utilService: UtilService,
		public dialog: MatDialog,
		public accountSettings: AccountSettingsService,
		private carrierFeedbackService: CarrierFeedbackService,
		private router: Router,
		public productsService: ProductsService
	) {
		this.USER_ACCOUNT_TYPE = this.cargochief.USER_ACCOUNT_TYPE;
	}

	ngOnInit() {
		if (!this.utilService.isNullOrUndefined(this.capacitySearch)) {
			this.getContactsList();
		}
		this.accountId = this.cargochief.ACCOUNT_ID;
	}

	getContactsList() {
		this.isContactsListInProgress = true;
		this.contactList = null;
		const contactsUrl = this.urlService.contactsUrl(this.capacitySearch.carrierId);
		this.restService.GET(contactsUrl).subscribe(
			(result) => {
				result['carrier'] = this.getCarrierInfo();
				this.segmentWrapper.fireSegmentEvent(SegmentEventsConstants.contact_requested, result);
				this.contactList = result['data'];
				this.isContactsListInProgress = false;
				if (!this.utilService.isNullOrUndefined(this.contactList) && this.contactList.length == 0) {
					this.segmentWrapper.fireSegmentEvent(
						SegmentEventsConstants.carrier_missing_contact_info,
						{ carrier: this.getCarrierInfo() }
					);
				}
			},
			(error) => {
				this.utilService.showSnackbar(
					'Cannot fetch contact list.',
					SNACKBAR.ERROR,
					SNACKBAR.ACTION
				);
				this.contactList = [];
				this.isContactsListInProgress = false;
			}
		);
	}

	getCarrierInfo() {
		return {
			businessName: this.capacitySearch.businessName,
			mc: this.capacitySearch.firmMc,
			dot: this.capacitySearch.firmDot,
			carrierId: this.capacitySearch.carrierId,
		};
	}

	openLaneDetailsView() {
		const data = {
			lane: this.capacitySearch,
		};
		this.router.navigate([], {
			queryParams: {
				fullProfile: 'true',
			},
			queryParamsHandling: 'merge',
		});
		this.openLaneDetails.emit(data);
	}

	updateContactsList(updatedList: Array<ContactsTable>) {
		this.contactList = [...updatedList];
	}
}
